import { AxiosError } from 'axios';
import {
  IDEMPOTENT_METHODS,
  MAX_RETRY_COUNT,
  RETRYABLE_CODES,
  RETRYABLE_STATUSES,
  RETRY_BASE_DELAY,
} from 'models/Error';

export const getMaxRetryCount = (config?: Record<string, any>) =>
  (config && config.__maxRetryCount) ?? MAX_RETRY_COUNT;

export const isIdempotentMethod = (method?: string) =>
  !!method && IDEMPOTENT_METHODS.includes(method.toLowerCase());

export const isRetryableError = (error: AxiosError) => {
  const isIdempotent = isIdempotentMethod(error.config?.method);

  const noResponse = !error.response;

  const codeRetryable = !!error.code && RETRYABLE_CODES.includes(error.code);

  const statusRetryable =
    !!error.response?.status &&
    RETRYABLE_STATUSES.includes(error.response.status);

  return isIdempotent && (codeRetryable || statusRetryable || noResponse);
};

export const delay = (retry: number, ms = RETRY_BASE_DELAY) =>
  new Promise((resolve) => setTimeout(resolve, ms * retry));
